import Byd from '@/utils/Byd.js'


/**
 * @description 获取品牌
 * @params {hideNavBar: 1,needAuthCode:1 }
 */
export function getBrandFromBridge() {
  console.log('进入getBrandFromBridge==>')
  try{
    if(localStorage.getItem('brand')) {
        console.log('进入getBrandFromBridge 有brand信心了==>')
      return 
    }else{
      // 这里是异步的。success是异步的。会比外面的requestAnimationFrame再次递归后执行
      Byd.getSystemInfo(
      {},
      {
        success: res => {
          console.log('getBrandFromBridge 调用成功:', res.data)
          localStorage.setItem('brand',res.data.channel)
        },
        fail: err => {
          console.log('getBrandFromBridge 调用失败:', err.error)
        },
      }
    )
    }
    
  }catch(err) {
   console.log('getBrandFromBridge catch:', err.error)
  }
}

/**
 * 埋点方法
 * @param {Object} options - 埋点参数对象
 * @param {Object} options.param - 业务参数
 */
export async function  track ({ param }) {
  try {
    const data = {
      ...param,
      reportTime: Date.now(),
    }

    // 从URL获取sign参数
    const urlParams = new URLSearchParams(window.location.search)
    const sign = urlParams.get('sign')
    if (sign) {
      data.sign = sign
    }

    await new Promise((resolve) => {
      const localStorageBrand=localStorage.getItem('brand')
      if(localStorageBrand) {
        data.brand=Number(localStorageBrand)
         console.log('使用localStorageBrand', localStorageBrand)
        resolve()
      }else{
          Byd.getSystemInfo(
          {},
          {
            success: res => {
              console.log('getSystemInfo 调用成功:', res.data)
              data.brand = res.data.channel
              localStorage.setItem('brand',res.data.channel)
              resolve()
            },
            fail: err => {
              console.log('getSystemInfo 调用失败:', err.error)
              resolve()
            },
          }
        )
      }
    })
    let baseURL = process.env.VUE_APP_OPEN_API ? process.env.VUE_APP_OPEN_API : process.env.VUE_APP_BASE_API
      // 降级方案：使用 fetch 且 keepalive 为 true
      const url = baseURL + '?s=Customer.Web.reportUserBuried'
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' },
        keepalive: true  // 页面卸载时保持请求
      })

    // 开发环境打印日志
    if (process.env.NODE_ENV === 'development') {
      console.log('[Tracking] 埋点数据:', data)
    }

    return true
  } catch (error) {
    console.error('[Tracking] 埋点失败:', error)
    return false
  }
}

export default track
